import { render, staticRenderFns } from "./accountingLedger.vue?vue&type=template&id=ec38998a&scoped=true&"
import script from "./accountingLedger.vue?vue&type=script&lang=js&"
export * from "./accountingLedger.vue?vue&type=script&lang=js&"
import style0 from "./accountingLedger.vue?vue&type=style&index=0&lang=css&"
import style1 from "./accountingLedger.vue?vue&type=style&index=1&id=ec38998a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec38998a",
  null
  
)

export default component.exports